import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

/** Renders children only if the named feature flag is enabled OR the user is an admin.
 *  Admins can always access every screen so we don't accidentally lock ourselves out.
 *  While flags are still loading (undefined) we render nothing to avoid a flash of the
 *  page followed by a redirect.
 */
export function FeatureGate({ flag, children }) {
  const { user, featureFlags, featureFlagsLoaded } = useAuth();
  if (!featureFlagsLoaded) return null;
  const isAdmin = user?.role === "admin";
  const enabled = featureFlags?.[flag];
  const financeUser = user?.role === "treasurer" || user?.is_treasurer === true || user?.is_expense_approver === true;
  if (isAdmin) return children;
  if (enabled) return children;
  if (flag === "expenses" && financeUser) return children;
  return <Navigate to={user?.role === "treasurer" ? "/app/finance" : "/app/calendar?disabled=1"} replace />;
}
